import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import Button from "../../Components/Button/Button";
import CarouselAndAudioPlayer from "../../Components/CarouselAndAudioPlayer/CarouselAndAudioPlayer";
import CropperModal from "../../Components/CropperModal/CropperModal";
import Header from "../../Components/Header/Header";
import InputBox from "../../Components/InputBox/InputBox";
import Modal from "../../Components/Modal/Modal";
import TrackProgress from "../../Components/TrackProgress/TrackProgress";
import {
  complaintTakeover,
  fetchCompliantAssets,
  fixComplaints,
  setSelectedComplaint,
  updateComplaints
} from "../../Redux/complaints/action";
import { isValidArray, isValidObject } from "../../Services/validators";
import {
  getSelectedComplaintsDetailsData,
  getSelectedComplaintsUpdatesData
} from "../../Utils/Complaints";
import "./SelectedComplaint.css";
import { getAppsUrls } from "../../Utils/constants";
import { ShareCard } from "../../Components/Card/Card";

function SelectedComplaint(props) {
  const [isTakenOverByMe, setIsTakenOverByMe] = useState(false);
  const { complaintId } = useParams();
  const [file, setFile] = useState({
    image: [],
    audio: null
  });
  const [croppedImage, setCroppedImage] = useState({ images: [] });
  const [formData, setFormData] = useState({ remarks: "", update: "" });
  const [showShareModal, setShowShareModal] = useState(false);

  useEffect(() => {
    if (complaintId) {
      props.setSelectedComplaint(complaintId, props.navigate);
    }
    setFormData({ remarks: "", update: "" });
    setCroppedImage({ images: [] });
    setFile({ image: [], audio: null });
    return () => {
      props.setSelectedComplaint(null);
    };
    // eslint-disable-next-line
  }, [complaintId]);

  useEffect(() => {
    if (!complaintId) {
      return;
    }

    let intervalId;
    let isCancelled = false;

    const fetchUntilAssetsAvailable = () => {
      const complaint = props.complaints?.selectedComplaint;
      if (!isValidObject(complaint)) {
        return;
      }

      const updates = complaint?.latestUpdate || [];

      const rootAssetCount =
        (Array.isArray(complaint.assets) ? complaint.assets.length : 0) +
        (complaint.audio ? 1 : 0);

      const rootProofCount =
        (complaint.proof?.images?.length || 0) +
        (complaint.proof?.audio ? 1 : 0);

      const isRootAssetIncomplete =
        rootAssetCount > 0 && rootProofCount !== rootAssetCount;

      const updatesNeedAssets = updates.some((update) => {
        if (!update.proof) return false;

        const proofLen = update.proof?.length || 0;
        const assetLen =
          (update.assets?.images?.length || 0) + (update.assets?.audio ? 1 : 0);

        return proofLen !== assetLen;
      });

      if (!isCancelled && (isRootAssetIncomplete || updatesNeedAssets)) {
        props.fetchCompliantAssets();
      } else if (!isRootAssetIncomplete && !updatesNeedAssets) {
        clearInterval(intervalId);
      }
    };

    fetchUntilAssetsAvailable();
    intervalId = setInterval(fetchUntilAssetsAvailable, 2000);

    return () => {
      isCancelled = true;
      if (intervalId) clearInterval(intervalId);
    };
    // eslint-disable-next-line
  }, [complaintId, props.complaints?.selectedComplaint]);

  useEffect(() => {
    const takenOver =
      props.complaints?.selectedComplaint?.takenOverBy &&
      isValidObject(props.complaints?.selectedComplaint?.takenOverBy)
        ? props.complaints?.selectedComplaint?.takenOverBy?.employeeId ===
          props.profile.data?.employeeId
        : false;

    setIsTakenOverByMe(takenOver);
  }, [
    props.complaints?.selectedComplaint?.takenOverBy,
    props.profile.data?.employeeId
  ]);

  return (
    <>
      <div className="inherit-parent-height inherit-parent-width overflow-hidden">
        <Header
          theme={props.auth.theme.primaryColor === "#0E0E0E" ? "dark" : "light"}
          title="Complaint Details"
          backOnClick={() => {
            props.navigate("/complaints");
          }}
          shareOnclick={() => setShowShareModal(true)}
        />
        <div
          data-cy="SELECTED-COMPLAINT-CONTAINER"
          className="remaining-body-height inherit-parent-width display-flex flex-justify-content-center overflow-scroll hide-scrollbar"
        >
          <div className="inherit-parent-height inherit-parent-width padding-right-large padding-left-large">
            <TrackProgress
              title="Details"
              state={
                props.complaints?.selectedComplaint?.takenOverBy?.employeeId
                  ? "INACTIVE"
                  : "ACTIVE"
              }
              data={
                <div className="inherit-parent-width">
                  <ComplaintDetails
                    data={props.complaints?.selectedComplaint}
                    complaintsLoading={props.complaintsLoading}
                  />
                </div>
              }
            />

            {props.complaints?.selectedComplaint?.latestUpdate?.map(
              (data, i) => (
                <div key={i}>
                  <TrackProgress
                    title={data?.description}
                    state="INACTIVE"
                    data={
                      <div className="inherit-parent-width">
                        <ComplaintUpdates
                          data={data}
                          complaintsLoading={props.complaintsLoading}
                        />

                        {props.complaints?.selectedComplaint?.latestUpdate
                          .length -
                          1 !==
                          i && (
                          <div
                            style={{
                              height: "2px",
                              backgroundColor: "grey",
                              width: "100%"
                            }}
                          />
                        )}
                      </div>
                    }
                  />
                </div>
              )
            )}

            {(!isValidObject(
              props.complaints?.selectedComplaint?.takenOverBy
            ) ||
              isTakenOverByMe) && (
              <TrackProgress
                title="Manage"
                isLast={true}
                state={
                  props.complaints?.selectedComplaint?.takenOverBy
                    ?.employeeId ||
                  props.complaints?.selectedComplaint?.status?.currentStatus ===
                    "UNDER REVIEW"
                    ? "ACTIVE"
                    : "PROGRESS"
                }
                isTakenOverByMe={isTakenOverByMe}
                data={
                  <div className="inherit-parent-width">
                    <ComplaintManage
                      formData={formData}
                      setFormData={setFormData}
                      complaintsLoading={props.complaintsLoading}
                      isTakenOverByMe={isTakenOverByMe}
                      closeComplaintClick={() => {
                        props.fixComplaints({
                          remarks: formData.remarks,
                          complaintId,
                          locationId:
                            props.complaints?.selectedComplaint?.locationId,
                          proof: {
                            image: croppedImage.images,
                            audio: file.audio
                          },
                          navigate: props.navigate
                        });
                      }}
                      addUpdateClick={() => {
                        props.updateComplaints(
                          formData.update,
                          complaintId,
                          props.complaints?.selectedComplaint?.locationId,
                          {
                            image: croppedImage.images,
                            audio: file.audio
                          }
                        );
                        setFormData({ update: "" });
                        setCroppedImage({
                          images: []
                        });
                        setFile({
                          image: [],
                          audio: null
                        });
                      }}
                      loading={props.complaints.loading}
                      croppedImage={croppedImage}
                      data={props.complaints?.selectedComplaint}
                      file={file}
                      setCroppedImage={setCroppedImage}
                      setFile={setFile}
                      takeOverOnClick={() => {
                        const profileData = props.profile.data;
                        props.complaintTakeover(complaintId, {
                          employeeId: profileData.employeeId,
                          employeeName: profileData.name,
                          phoneNumber: profileData.phoneNumber
                        });
                      }}
                      verifyCompliantClick={(type) => {
                        props.verifyCompliantClick(type);
                      }}
                    />
                  </div>
                }
              />
            )}
          </div>
        </div>
        <Modal
          show={showShareModal}
          canIgnore={true}
          onClose={() => setShowShareModal(false)}
          width="inherit-parent-width"
          maxWidth="none"
          minWidth="none"
          height="none"
          background="background-color-primary"
          position="position-absolute bottom-0 right-0 left-0"
          borderRadius="false"
        >
          <div
            className="font-color-tertiaryColor margin-larger"
            style={{ width: "calc(100% - 48px)" }}
            data-cy="SHARE-MODAL"
          >
            <div className="flex-justify-content-center flex-direction-column flex-align-items-center ">
              <div className="font-size-large margin-bottom-small padding-bottom-smaller">
                Share Complaint
              </div>
              <div className="font-color-tertiaryColor6 font-size-medium margin-bottom-larger">
                Can access the complaint through connected apps
              </div>
            </div>
            <div
              className="display-flex flex-direction-column"
              style={{ gap: "24px" }}
            >
              {Object.values(getAppsUrls).map((data) => {
                const isPublic = data.key === "public";
                if (isPublic) {
                  return null;
                }
                return (
                  <ShareCard
                    key={data.key}
                    data={data}
                    complaintId={
                      props.complaints?.selectedComplaint?.documentId
                    }
                  />
                );
              })}
            </div>
          </div>
        </Modal>

        <Modal
          show={isValidArray(file?.image)}
          canIgnore={true}
          onClose={() => {
            setFile({ ...file, image: [] });
          }}
          width="inherit-parent-width"
          maxWidth="max-width-800px"
          background="false"
          boxShadow="false"
          borderRadius="false"
          height="inherit-parent-height max-height-500px"
        >
          <div
            data-cy="cropper-modal"
            className={`inherit-parent-height font-color-tertiaryColor6 background-color-tertiaryColor1`}
          >
            <CropperModal
              className="border-radius-default"
              OnBlobCreate={(blob) => {
                const imageFile = new File([blob], `${+new Date()}.png`, {
                  type: "image/png"
                });
                setCroppedImage({
                  images: [...croppedImage.images, imageFile]
                });
              }}
              file={file.image}
              setFile={() => {
                setFile({ ...file, image: [] });
              }}
            />
          </div>
        </Modal>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  complaints: state.complaints,
  profile: state.profile,
  locations: state.locations
});

const mapDispatchToProps = function () {
  return {
    fixComplaints: ({ remarks, complaintId, locationId, proof, navigate }) =>
      fixComplaints({ remarks, complaintId, locationId, proof, navigate }),
    updateComplaints: (remarks, complaintId, locationId, proof) =>
      updateComplaints(remarks, complaintId, locationId, proof),
    fetchCompliantAssets: () => fetchCompliantAssets(),
    complaintTakeover: (complaintId, employeeData) =>
      complaintTakeover(complaintId, employeeData),
    setSelectedComplaint: (complaintId, navigate) =>
      setSelectedComplaint(complaintId, navigate)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SelectedComplaint);

const ComplaintDetails = (props) => {
  return (
    <div className="inherit-parent-width">
      {getSelectedComplaintsDetailsData(props.data)?.map(
        (data, i) =>
          isValidArray(data) && (
            <div key={i}>
              <Fields title={data?.[0]} data={data?.[1]} />
            </div>
          )
      )}
    </div>
  );
};

const ComplaintManage = (props) => {
  const [show, setShow] = useState({
    closeComplaint: false,
    updateComplaint: false
  });

  const [isAudioRecording, setIsAudioRecording] = useState(false);

  const [handleCloseComplaintDisable, setHandleCloseComplaintDisable] =
    useState(true);

  const [handleAddUpdateDisable, setHandleAddUpdateDisable] = useState(true);

  useEffect(() => {
    const isDisabled = !isValidArray(props.croppedImage.images);

    setHandleCloseComplaintDisable(isDisabled);
  }, [props.croppedImage.images]);

  useEffect(() => {
    if (isAudioRecording) {
      setHandleAddUpdateDisable(true);
      return;
    }

    const isDisabled = !(
      (props.formData.update.trim() &&
        isValidArray(props.croppedImage.images)) ||
      props.file.audio !== null
    );

    setHandleAddUpdateDisable(isDisabled);
  }, [
    props.formData.update,
    props.croppedImage.images,
    props.file.audio,
    isAudioRecording
  ]);

  return (
    <div className="inherit-parent-width">
      {props.isTakenOverByMe &&
        props.data?.status?.currentStatus === "OPEN" && (
          <div className="inherit-parent-width padding-top-default">
            {show.closeComplaint && (
              <div
                style={{
                  paddingBottom:
                    props.croppedImage?.images?.length > 0 ? "16px" : "0px"
                }}
              >
                <InputBox
                  className="inherit-parent-width margin-top-large"
                  name="name"
                  label="REMARKS"
                  type="text"
                  onChange={(e) => {
                    props.setFormData({
                      ...props.formData,
                      remarks: e.target.value
                    });
                  }}
                  placeholder="Enter remarks"
                  removeResponsive={true}
                  value={props.formData?.remarks}
                  fontColor="font-color-tertiaryColor"
                  labelFontColor="font-color-tertiaryColor"
                  data-cy="ADD-REMARKS-FIELD"
                  disabledBackgroundColor="transparent"
                />
              </div>
            )}

            {show.updateComplaint && (
              <div
                style={{
                  paddingBottom:
                    props.croppedImage?.images?.length > 0 ? "16px" : "0px"
                }}
              >
                <InputBox
                  className="inherit-parent-width margin-top-large"
                  name="name"
                  label="UPDATE*"
                  type="text"
                  onChange={(e) => {
                    props.setFormData({
                      ...props.formData,
                      update: e.target.value
                    });
                  }}
                  placeholder="Enter update"
                  removeResponsive={true}
                  value={props.formData?.update}
                  fontColor="font-color-tertiaryColor"
                  labelFontColor="font-color-tertiaryColor"
                  data-cy="ADD-UPDATE-FIELD"
                  disabledBackgroundColor="transparent"
                  required
                />
              </div>
            )}
            <CarouselAndAudioPlayer
              // dataCy={data?.title}
              isAudioRecoding={setIsAudioRecording}
              assetsLoading={props.complaintsLoading?.assets}
              setCroppedImage={props.setCroppedImage}
              fileSrc={props.croppedImage}
              dataCy="COMPLAINT-MANAGE"
              setFile={props.setFile}
              file={props.file}
              add={show.closeComplaint || show.updateComplaint ? true : false}
              setErrorStatus={props.setErrorStatus}
              onImageClick={(data) => {
                if (typeof props.setPreviewImage === "function") {
                  props.setPreviewImage(data);
                }
              }}
            />
          </div>
        )}

      {props.isTakenOverByMe &&
        (props.data?.status?.currentStatus === "UNDER REVIEW" ||
          props.data?.status?.currentStatus === "CLOSED") && (
          <div className="inherit-parent-width padding-top-default">
            <CarouselAndAudioPlayer
              assetsLoading={props.complaintsLoading?.assets}
              fileSrc={props.data?.closure?.fileSrc}
              onImageClick={(data) => {
                if (typeof props.setPreview === "function") {
                  props.setPreview(data);
                }
              }}
            />
          </div>
        )}

      {!isValidObject(props.data?.takenOverBy) && (
        <Button
          type="button"
          text="TAKEOVER"
          boxShadow={false}
          loading={props.loading}
          onClick={props.takeOverOnClick}
          className="margin-top-large"
          data-cy="TAKEOVER-CONFIRM-BUTTON"
        />
      )}

      {props.data?.status?.currentStatus === "UNDER REVIEW" && (
        <>
          <div className="text-align-center font-size-small padding-top-large font-color-tertiaryColor6">
            YOU CAN EITHER CLOSE THE COMPLAINT OR REOPEN IF THE MEDIA IS
            INCORRECT
          </div>
          <div className="display-flex flex-direction-column inherit-parent-width flex-justify-content-space-between margin-top-large">
            <Button
              boxShadow={false}
              type="button"
              text="Verify & Close complaint"
              onClick={() => {
                props.verifyCompliantClick("CLOSE");
              }}
              data-cy="VERIFY-CLOSE-COMPLAINT-BUTTON"
            />
            <Button
              boxShadow={false}
              type="button"
              variant="transparent"
              text="Reopen Complaint"
              className="padding-top-large"
              onClick={() => {
                props.verifyCompliantClick("OPEN");
              }}
              data-cy="VERIFY-REOPEN-COMPLAINT-BUTTON"
            />
          </div>
        </>
      )}
      
      {props.data?.status?.currentStatus === "OPEN" &&
      props.isTakenOverByMe &&
      Object.values(show).every((data) => data === false) ? (
        <div className="display-flex">
          <div
            style={{
              width: "100%"
            }}
            className="padding-right-default"
          >
            <Button
              type="button"
              // className="margin-top-larger"
              text="RESOLVE ISSUE"
              boxShadow={false}
              loading={props.loading}
              onClick={() => {
                setShow({ closeComplaint: true, updateComplaint: false });
              }}
              data-cy="RESOLVE-ISSUE-BUTTON"
            />
          </div>
          <div
            style={{
              width: "100%"
            }}
            className="padding-left-default"
          >
            <Button
              type="button"
              variant="transparent"
              // className="margin-top-larger"
              text="ADD UPDATE"
              boxShadow={false}
              onClick={() => {
                setShow({ closeComplaint: false, updateComplaint: true });
              }}
              data-cy="ADD-UPDATE-BUTTON"
            />
          </div>
        </div>
      ) : (
        <>
          {show.closeComplaint && (
            <div className="display-flex inherit-parent-width">
              <div className="padding-right-default inherit-parent-width">
                <Button
                  type="button"
                  className="margin-top-larger"
                  text="CLOSE COMPLAINT"
                  boxShadow={false}
                  loading={props.loading}
                  onClick={props.closeComplaintClick}
                  disabled={handleCloseComplaintDisable}
                  data-cy="CLOSE-COMPLAINT-BUTTON"
                />
              </div>
              <div className="padding-left-default inherit-parent-width">
                <Button
                  type="button"
                  variant="transparent"
                  className="margin-top-larger"
                  text="CANCEL"
                  boxShadow={false}
                  onClick={() => {
                    setShow({
                      closeComplaint: false,
                      updateComplaint: false
                    });
                  }}
                  data-cy="CANCEL-BUTTON"
                />
              </div>
            </div>
          )}

          {show.updateComplaint && (
            <div className="display-flex inherit-parent-width">
              <div className="padding-right-default  inherit-parent-width">
                <Button
                  type="button"
                  className="margin-top-larger"
                  text="ADD UPDATE"
                  boxShadow={false}
                  loading={props.loading}
                  onClick={props.addUpdateClick}
                  disabled={handleAddUpdateDisable}
                  data-cy="ADD-UPDATE-BUTTON"
                />
              </div>
              <div className="padding-left-default  inherit-parent-width">
                <Button
                  type="button"
                  variant="transparent"
                  className="margin-top-larger"
                  text="CANCEL"
                  boxShadow={false}
                  onClick={() => {
                    setShow({
                      closeComplaint: false,
                      updateComplaint: false
                    });
                  }}
                  data-cy="UPDATE-CANCEL-BUTTON"
                />
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

const ComplaintUpdates = (props) => {
  return (
    <div className="inherit-parent-width">
      {getSelectedComplaintsUpdatesData(props.data)?.map(
        (data, i) =>
          isValidArray(data) && (
            <div key={i}>
              <Fields title={data?.[0]} data={data?.[1]} />
            </div>
          )
      )}
      <div className="padding-top-large" />
      {isValidObject(props.data?.assets) && (
        <div className="inherit-parent-width">
          <CarouselAndAudioPlayer
            dataCy="COMPLAINT-UPDATE"
            assetsLoading={props.complaintsLoading?.assets}
            fileSrc={props.data?.assets}
            onImageClick={(data) => {
              if (typeof props.setPreview === "function") {
                props.setPreview(data);
              }
            }}
          />
        </div>
      )}
    </div>
  );
};

export const Fields = (props) => {
  return (
    <div className="display-flex padding-top-large">
      <div className="display-flex">
        <div
          className="white-space-no-wrap font-color-tertiaryColor6"
          style={{ width: "150px" }}
          data-cy={`${props.title}`}
        >
          {props.title}
        </div>
      </div>
      <div
        className={`text-align-left inherit-parent-width text-overflow-ellipsis font-color-tertiaryColor ${
          !props.removeCapitalize && "text-capitalize"
        }`}
        data-cy={props.dataCy || props.data}
        style={{
          // minWidth: "fit-content",
          // maxWidth: "380px",
          textWrap: "wrap"
        }}
      >
        {props.data}
      </div>
    </div>
  );
};
